module.exports = __webpack_public_path__ + "img/icon_zuixing_normal@2x.7c896f66.png";